import request from 'utils/request'

/**
 * 获取列表
 * @param {*} data
 */

export const getRecordList = data => request().post('business/rule/page', data)
//下载
export const exportCreditHistory = data =>
  request().post(`business/rule/down`, data, { responseType: 'blob' })
//业务类型
export const getBusinessList = () => request().get('business/jsonList')
//获取业务模式
export const getModelList = data => request().post('business/region/list', data)
